import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "intake-card__title intake-card__title--stacked" };
const _hoisted_2 = { class: "intake-card__subtitle" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_5 = { class: "text-caption text-medium-emphasis" };
const _hoisted_6 = { class: "text-body-2 text-truncate" };
import { computed } from "vue";
import IntakeCardTitle from "@/components/intakeReview/IntakeCardTitle.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepCoverageCard',
    props: {
        coverage: {},
        selected: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const BENEFITS = { pharmacy_benefits: "Pharmacy", medical_benefits: "Medical" };
        const SOURCES = {
            manual: { label: "Manual entry", title: "Typed by staff", color: "primary" },
            roster: { label: "Roster", title: "From the client's patient roster", color: "blue-grey" },
            order_submission: { label: "PA", title: "From a prior auth submission", color: "blue-grey" },
            intake_card: { label: "Card", title: "From an intake insurance card", color: "blue-grey" },
        };
        const source = computed(() => SOURCES[props.coverage.source ?? "roster"] ?? SOURCES.roster);
        const facts = computed(() => [
            { label: "Member ID", value: props.coverage.memberId || "Not on file" },
            { label: "Benefit type", value: BENEFITS[props.coverage.benefitType] ?? props.coverage.benefitType },
            { label: "Group", value: props.coverage.groupNumber },
            { label: "BIN", value: props.coverage.rxBin },
            { label: "PCN", value: props.coverage.rxPcn },
        ].filter((fact) => fact.value));
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, {
                class: "intake-card intake-card--selected mb-4",
                color: "surface",
                "data-testid": "step-coverage-card"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(IntakeCardTitle, {
                            variant: "row",
                            title: "Coverage"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_chip, {
                                    size: "small",
                                    rounded: "lg",
                                    variant: "tonal",
                                    color: source.value.color,
                                    title: source.value.title
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(source.value.label), 1)
                                    ]),
                                    _: 1
                                }, 8, ["color", "title"])
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createTextVNode(_toDisplayString(__props.coverage.insuranceProvider || "Payer not on file") + " ", 1),
                            (__props.coverage.insurancePlanType)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " · " + _toDisplayString(__props.coverage.insurancePlanType), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "intake-card__meta" }, "Current values on file for this coverage", -1)),
                        (__props.selected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_chip, {
                                    color: "success",
                                    variant: "flat",
                                    size: "small",
                                    rounded: "",
                                    "prepend-icon": "mdi-check"
                                }, {
                                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                            _createTextVNode("Selected", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facts.value, (fact) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                            key: fact.label,
                                            cols: "6",
                                            sm: "3"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, _toDisplayString(fact.label), 1),
                                                _createElementVNode("div", _hoisted_6, _toDisplayString(fact.value), 1)
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
